import { connect } from 'react-redux';
import { bindActionCreators, type Dispatch } from 'redux';
import { blurField, changeField, focusField, setUI } from '../../actions';
import { makeValueSelector } from '../../selectors';
import type { SchemaFieldProps, SchemaFormSlice } from '../../types';
import ScalarField from './scalar-field';

const getMapStateToProps = () => {
  const selector = makeValueSelector();
  return (state: SchemaFormSlice, props: SchemaFieldProps) => selector(state, props);
};

const mapDispatchToProps = (dispatch: Dispatch, { formName, path }: SchemaFieldProps) =>
  bindActionCreators(
    {
      onChange: changeField(formName, path, false),
      onChangeSilent: changeField(formName, path, true),
      onBlur: blurField.bind(null, formName, path),
      onFocus: focusField.bind(null, formName, path),
      setUI: setUI.bind(null, formName, path)
    },
    dispatch
  );

export default connect(getMapStateToProps, mapDispatchToProps)(ScalarField);
